import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import { Grid, Paper, Button, InputBase } from "@material-ui/core";
import Header from "../../../partials/header";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Loading from "../../loading";
import GetAppIcon from "@material-ui/icons/GetApp";
export class Plugin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "",
      discontinued: "",
      on_sale: "",
      stock_status: "",
      enableb: "",
      search: "",
      // selectedName: "",
    };
  }
  async componentDidMount() {
    this.props.getPluginCategory();
    const { match } = this.props;
    let { id = "" } = match.params;
    if (id)
      this.setState({
        selectedCategory: id,
      });
    this.getPlugin({ category_id: id });
  }
  idAddedPlugin = (pluginKey) => {
    // true => added
    const { listPluginsService } = this.props;
    return (
      listPluginsService.findIndex((item) => item.pluginKey === pluginKey) !==
      -1
    );
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
  };
  getPlugin = async (payload = {}) => {
    this.loading.startLoading();
    await this.props.getPlugin(payload);
    this.loading.stopLoading();
  };
  handlelistPlugin = (category = {}) => {
    let category_id = category.categoryId || "";
    this.setState({
      selectedCategory: category_id,
    });
    this.getPlugin({ category_id: category_id });
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        discontinued: "",
        on_sale: "",
        stock_status: "",
        enableb: "",
      },
      function () {
        _this.getPlugin();
      }
    );
  };
  handleFilter = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
    this.getPlugin({ search: value });
  };

  submitAddPlugin = async (plugin) => {
    this.loading.startLoading();
    await this.props.createPluginService({ pluginKey: plugin.key });
    this.loading.stopLoading();
  };
  submitRemovePlugin = async (plugin) => {
    this.loading.startLoading();
    await this.props.removePluginService({ pluginKey: plugin.key });
    this.loading.stopLoading();
  };
  render() {
    const {
      t,
      classes,
      listPluginCategory = [],
      listPlugin = [],
      i18n,
    } = this.props;
    // let selectedName = this.state.selectedName || t("plugin_category_all");
    let { selectedCategory } = this.state;
    return (
      <>
        <Header session={t("plugin")} title={t("Power ups")} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.paper}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sm={3}
              md={3}
              lg={3}
              style={{ paddingRight: "1rem" }}
            >
              <div className={classes.search}>
                <InputBase
                  className={classes.inputSearch}
                  classes={{
                    input: classes.inputInputSearch,
                  }}
                  value={this.state.search}
                  placeholder={t("plugin_category_search_by_name")}
                  name="search"
                  onChange={this.handleChange}
                />
              </div>
              <List
                component="nav"
                aria-label="main mailbox folders"
                className={classes.list}
              >
                <ListItem
                  button
                  className={!selectedCategory ? classes.selectedItem : ""}
                  onClick={() => this.handlelistPlugin()}
                >
                  {/* <ListItemIcon>
                    <FolderIcon />
                  </ListItemIcon> */}
                  <ListItemText
                    primary={t("plugin_category_all")}
                    classes={{
                      primary:
                        selectedCategory !== ""
                          ? classes.listItemTextHead
                          : classes.listItemTextHeadSelected,
                    }}
                  />
                </ListItem>
                {listPluginCategory.map((item, index) => (
                  <ListItem
                    button
                    key={index}
                    className={
                      selectedCategory === item.categoryId
                        ? classes.selectedItem
                        : ""
                    }
                    onClick={() => this.handlelistPlugin(item)}
                  >
                    {/* <ListItemIcon>
                      <FolderIcon />
                    </ListItemIcon> */}
                    <ListItemText
                      primary={
                        i18n.language === "vn"
                          ? item.name && item.name.vi
                          : item.name && item.name.en
                      }
                      classes={{
                        primary:
                          selectedCategory !== item.categoryId
                            ? classes.listItemTextHead
                            : classes.listItemTextHeadSelected,
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} sm={9} md={9} lg={9}>
              <div className={classes.wrapPlugin}>
                {listPlugin.map((e, index) => {
                  let isAdded = this.idAddedPlugin(e.key);
                  return (
                    <div key={index} className={classes.containerPlugin}>
                      <div
                        className={classes.image}
                        onClick={() =>
                          this.props.history.push(`/plugin/${e.key}`)
                        }
                      >
                        {e.image && (
                          <img className={classes.image} src={e.image} />
                        )}
                      </div>
                      <div className={classes.content}>
                        <div
                          className={classes.containerName}
                          onClick={() =>
                            this.props.history.push(`/plugin/${e.key}`)
                          }
                        >
                          <div
                            className={classes.icon}
                            style={{
                              backgroundImage: e.icon
                                ? `url(${e.icon}`
                                : `url('/images/noneImage.svg')`,
                            }}
                          />
                          {e.name}
                        </div>
                        <div className={classes.containerContent}>
                          {isAdded ? (
                            <Button
                              variant="contained"
                              color="secondary"
                              className={classes.buttonRemove}
                              size="small"
                              onClick={() => this.submitRemovePlugin(e)}
                            >
                              {t("plugin_remove")}
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.button}
                              size="small"
                              onClick={() => this.submitAddPlugin(e)}
                            >
                              {t("plugin_add")}
                            </Button>
                          )}
                        </div>
                        <div className={classes.description}>
                          {e.shortDescription}
                        </div>
                        <div className={classes.containerContent}>
                          <GetAppIcon
                            style={{ marginLeft: "-6px", height: "18px" }}
                          />{" "}
                          {e.totalDownload}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  listPlugin: state.plugin.listPlugin,
  listPluginCategory: state.pluginCategory.listPluginCategory,
  listPluginsService: state.pluginServices.listPlugins,
});

const mapDispatch = (dispatch) => ({
  getPluginCategory: dispatch.pluginCategory.getPluginCategory,
  getPlugin: dispatch.plugin.getPlugin,
  createPluginService: dispatch.pluginServices.create,
  removePluginService: dispatch.pluginServices.remove,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(Plugin)));
